'use es6';

import { jsx as _jsx } from "react/jsx-runtime";
import { useCallback, useEffect, useState } from 'react';
import { connect } from 'react-redux';
import TrackingOverrideModal from 'AdsUI/components/campaign-reporting/TrackingOverrideModal';
import { usageTracker } from 'AdsUI/lib/usageTracker';
import { TrackingStatusKeys } from 'AdsUI/lib/Constants';
import { overrideEngagementLimitForAd } from 'AdsUI/actions/FBActions';

const TrackingOverrideModalContainer = ({
  entity,
  closeModal,
  dispatch,
  isInstagram,
  isTrackingErrorsModal,
  onFail,
  onSuccess
}) => {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(false);
  useEffect(() => {
    usageTracker.track('trackingStatusSurveyAction', {
      action: 'Opened override modal',
      status: TrackingStatusKeys.ALERT,
      isTrackingErrorsModal
    });
  }, [isTrackingErrorsModal]);
  const onConfirm = useCallback(() => {
    const {
      accountId,
      id
    } = entity;
    setLoading(true);
    setError(false);
    dispatch(overrideEngagementLimitForAd(accountId, id)).then(() => {
      closeModal();
      usageTracker.track('trackingStatusSurveyAction', {
        action: 'Closed override modal without overriding',
        status: TrackingStatusKeys.ALERT,
        isTrackingErrorsModal
      });

      if (onSuccess) {
        onSuccess();
      }
    }).catch(() => {
      setError(true);
      setLoading(false);

      if (onFail) {
        onFail();
      }
    });
  }, [entity, closeModal, dispatch, isTrackingErrorsModal, onSuccess, onFail]);
  const onCancel = useCallback(() => {
    closeModal();
    usageTracker.track('trackingStatusSurveyAction', {
      action: 'Closed override modal without overriding',
      status: TrackingStatusKeys.ALERT,
      isTrackingErrorsModal
    });

    if (onSuccess) {
      onSuccess();
    }
  }, [closeModal, isTrackingErrorsModal, onSuccess]);
  return /*#__PURE__*/_jsx(TrackingOverrideModal, {
    name: entity.name,
    isInstagram: isInstagram,
    loading: loading,
    error: error,
    onCancel: onCancel,
    onConfirm: onConfirm
  });
};

export default connect()(TrackingOverrideModalContainer);